import { Product } from "."

export const ViewProduct: React.FC = () => {
  return <Product />
}

